import { AvatarImage } from './AvatarImage.js';
import { AvatarPlaceholder } from './AvatarPlaceholder.js';
import { type AvatarProps } from './types.js';

export const Avatar = ({
  alt,
  avatarImage,
  avatarRef,
  deactivated,
  fallbackColor,
  fallbackName,
  onClick,
  previewImage,
  size = 'xs',
  ...props
}: AvatarProps) => {
  return avatarImage || previewImage ? (
    <AvatarImage
      alt={alt}
      avatarImage={avatarImage}
      avatarRef={avatarRef}
      deactivated={deactivated}
      onClick={onClick}
      previewImage={previewImage}
      size={size}
      {...props}
    />
  ) : (
    <AvatarPlaceholder
      deactivated={deactivated}
      fallbackColor={fallbackColor}
      fallbackName={fallbackName}
      onClick={onClick}
      ref={avatarRef}
      size={size}
      {...props}
    />
  );
};
